module.exports = __webpack_public_path__ + "static/media/Parquet.3b4f5bcd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/Parquet.svg
// module id = 375
// module chunks = 0